import React from "react";
import Helmet from "react-helmet";

interface Props {
  title: string;
}

const TitleMeta = (props: Props) => {
  const title = props.title;
  let prefixTitle = "SimplyBiz MyPortal";
  let defaultTitle = "SimplyBiz MyPortal";
  return (
    <Helmet>
      <title>{title ? prefixTitle + " | " + title : defaultTitle}</title>
    </Helmet>
  );
};

export default TitleMeta;
